import {
  number,
  string,
  shape,
  oneOfType,
  bool
} from 'prop-types';

export const AccessoryProps = {
  id: oneOfType([number, string]),
  name: string,
  info: string,
  image: string,
  price: number,
  showAdd: bool
};

export const AccessoryPropsShape = shape(AccessoryProps);

// Accessories data
export const AccessoryTypes = [
  {
    id: '1',
    name: 'Cabinets',
    info: null,
    price: 14,
    image: null,
    showAdd: false,
    type: 'Cabinets',
    removeMessage: 'Are you sure you want to remove cabinets ?',
    tooltipTitle: 'Cabinets',
    tooltipContent: 'Cabinets',
    tooltipImage: ''
  },
  {
    id: '5',
    name: 'Toe Kick',
    info: 'Adds a Toe Kick',
    price: 14,
    image: 'pathToImage',
    showAdd: false,
    type: 'Toe Kick',
    // eslint-disable-next-line max-len
    removeMessage: 'Toe Kicks are required to complete your base cabinet installation, to provide a continous finished look. Are you sure you want to remove',
    tooltipTitle: 'Toe Kick',
    tooltipContent: 'Required accessory to finish the recessed area at the bottom of your base cabinets. '
  + '(Quantity is based on your design)',
    tooltipImage: 'https://blinds.homedepot.com/product-images/1bf472d7-15da-ef11-848c-0afffee37a07.png?'
    + 'width=250&height=300&quality=70&mode=crop'
  },
  {
    id: '2',
    name: 'End Panels',
    info: 'End Panels are designed to cover the exposed sides of cabinets and create a finished look',
    price: 14,
    image: 'pathToImage',
    showAdd: true,
    type: 'Panels',
    removeMessage: 'Are you sure you want to remove end panels ?',
    tooltipTitle: 'End Panels',
    tooltipContent: 'End panels are designed to cover the exposed sides of cabinets and create a finished look.',
    tooltipImage: 'https://blinds.homedepot.com/product-images/600cf2c9-82da-ef11-848c-0afffee37a07.png?'
    + 'width=250&height=300&quality=70&mode=crop'
  },
  {
    id: '3',
    name: 'Cabinet Fillers',
    info: `Recommended for use with full overlay cabinets that are 
      flush against the wall to allow opening without rubbing`,
    price: 30,
    image: 'pathToImage',
    showAdd: true,
    type: 'Filler',
    removeMessage: 'Are you sure you want to remove cabinet fillers ?',
    tooltipTitle: 'Cabinet Fillers',
    tooltipContent: 'Recommended to “fill” openings or gaps between cabinets, or a cabinet and any obstruction,'
    + 'that would inhibit the doors or drawers from fully functioning.',
    tooltipImage: 'https://blinds.homedepot.com/product-images/0b54fc06-83da-ef11-848c-0afffee37a07.png?'
    + 'width=250&height=300&quality=70&mode=crop'
  },
  {
    id: '4',
    name: 'Moulding',
    info: 'Adds a finished trim look to your cabinet installation',
    price: 14,
    image: 'pathToImage',
    showAdd: true,
    type: 'Moulding',
    removeMessage: 'Are you sure you want to remove moulding ?',
    tooltipTitle: 'Edge Moulding',
    tooltipContent: 'Adds a finished trim look to your cabinet installation',
    tooltipImage: 'https://blinds.homedepot.com/product-images/c3fb0243-83da-ef11-848c-0afffee37a07.png?'
    + 'width=250&height=300&quality=70&mode=crop'
  },
];

export const tpCabTypes = {
  Filler: ['Filler'],
  Moulding: ['Moulding'],
  Panels: ['Panels']
};